import React from 'react';
import '../assets/css/HeaderBar.css';

function HeaderBar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom">
            <div className="container">
                <a href="/" className="navbar-brand d-flex align-items-center">
                    <img
                        src="logo_full.webp"
                        alt="Logo de l'association"
                        className="header-bar-logo"
                    />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                            <a href="/nous-rejoindre" className="nav-link">Devenir bénévole</a>
                        </li>
                        <li className="nav-item">
                            <a href="/se-former" className="nav-link">Se former</a>
                        </li>
                        <li className="nav-item">
                            <a href="/nous-contacter" className="nav-link">Nous contacter</a>
                        </li>
                    </ul>
                    <div className="d-flex">
                        <a
                            href="https://www.helloasso.com/associations/federation-des-secouristes-francais-croix-blanche/formulaires/2/widget"
                            className="btn btn-danger"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Faire un don
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default HeaderBar;
